/** @jsxImportSource @emotion/react */
import { Fragment } from 'react';

import { recommendationsPageAnalytics } from '../../analyticsConsts';
import {
  BOYS_OR_MEN,
  BOYS_OR_MEN_MIXED,
  CASUAL,
  CASUAL_LINK,
  CLUB,
  CLUB_CASUAL,
  CLUB_CASUAL_LINK,
  CLUB_LINK,
  CLUBS,
  CLUBS_CASUAL,
  DAY_PREFERENCE_DATA,
  DONT_MIND,
  GIRLS_AND_WOMEN_MIXED,
  GIRLS_OR_WOMEN,
  GIRLS_OR_WOMEN_MIXED,
  KICKABOUT_CASUAL,
  MIXED_VALUE,
  YES,
} from '../../const';
import { useFilterPanelToggleContext } from '../../context/filterPanelToggle';
import { useNestedFilterPanelContext } from '../../context/nestedFilterPanel';
import { usePreferencesContext } from '../../context/preferences';
import weekdaysFormatter from '../../formatters/weekdays';
import useDisabilityTitle from '../../hooks/useDisabilityTitle';
import ExternalLink from '../ExternalLink';
import filtersConfig from '../FiltersPanel/filtersConfig';
import LinkButton from '../LinkButton';
import Text from '../Text';
import useStyles from './styles';

const {
  RECOMMENDED_FOOTBALL_ONBOARDING_CTA_LEARN_MORE,
  RECOMMENDED_FOOTBALL_ONBOARDING_WRAPPER,
  RECOMMENDED_FOOTBALL_ONBOARDING_DAY_PREFERENCE,
} = recommendationsPageAnalytics;

const OnboardingCriteria = () => {
  const styles = useStyles();
  const { preferences } = usePreferencesContext();
  const { isFilterPanelToggled, setFilterPanelToggle } =
    useFilterPanelToggleContext();
  const { setSelectedFilters, setNested } = useNestedFilterPanelContext();
  const {
    Age,
    SelectedFootballType,
    PlayWith,
    Disabilityoption,
    WeekDays,
    FootballType,
  } = preferences;
  // const ageTitle = useAgeTitle();
  const disabilityTitle = useDisabilityTitle();
  const getFootballType = SelectedFootballType => {
    switch (SelectedFootballType) {
      case KICKABOUT_CASUAL:
        return CASUAL;
      case CLUB:
        return CLUBS;
      case CLUB_CASUAL:
        return CLUBS_CASUAL;
      default:
        return null;
    }
  };
  const footballType = getFootballType(FootballType);

  const ageTitle = (() => {
    switch (PlayWith) {
      case BOYS_OR_MEN_MIXED:
        return 'male';
      case GIRLS_OR_WOMEN_MIXED:
        return 'female';
      case BOYS_OR_MEN:
        return 'male';
      case GIRLS_OR_WOMEN:
        return 'female';
      case GIRLS_AND_WOMEN_MIXED:
        return 'any or mixed';
      default:
        return 'any or mixed';
    }
  })();

  const volunteer = JSON.parse(sessionStorage.getItem('ISVOLUNTEER'));
  return (
    <div
      css={styles.OnboardingWrapper}
      id={RECOMMENDED_FOOTBALL_ONBOARDING_WRAPPER}
    >
      {preferences && Object.keys(preferences).length !== 0 && (
        <Fragment>
          <Text css={styles.link}>
            <span css={styles.link}>for</span>
            {Age > 0 && (
              <LinkButton css={[styles.ageTitle, styles.link]}>
                {!volunteer && `${Age} year-old, `}
              </LinkButton>
            )}
            <LinkButton css={[styles.ageTitle, styles.link]}>
              {ageTitle}{' '}
              {PlayWith === BOYS_OR_MEN_MIXED ||
              PlayWith === GIRLS_OR_WOMEN_MIXED
                ? `or ${MIXED_VALUE} `
                : ''}{' '}
              gender,
            </LinkButton>
            {FootballType !== DONT_MIND && (
              <ExternalLink
                css={[styles.externalLink, styles.link]}
                id={RECOMMENDED_FOOTBALL_ONBOARDING_CTA_LEARN_MORE}
                href={
                  SelectedFootballType === KICKABOUT_CASUAL
                    ? CASUAL_LINK
                    : SelectedFootballType === CLUB
                    ? CLUB_LINK
                    : CLUB_CASUAL_LINK
                }
                aria-label={`Learn more about ${footballType} - opens in a new window`}
              >
                <span css={styles.footballLink}> {footballType} </span>football,
              </ExternalLink>
            )}
            <LinkButton
              css={[styles.ageTitle, styles.link]}
              tabIndex={Disabilityoption === YES ? 0 : -1}
            >
              {Disabilityoption === YES && `${disabilityTitle}`}
            </LinkButton>
            <span css={styles.link}>on</span>
            <LinkButton
              css={[styles.link, styles.daysLink]}
              id={RECOMMENDED_FOOTBALL_ONBOARDING_DAY_PREFERENCE}
              aria-label={`${weekdaysFormatter(
                WeekDays
              )} - click to open day preference filter`}
              onClick={() => {
                // set day preference data
                setSelectedFilters(
                  filtersConfig[SelectedFootballType][DAY_PREFERENCE_DATA]
                );
                setNested(true);
                setFilterPanelToggle(!isFilterPanelToggled);
              }}
            >
              {weekdaysFormatter(WeekDays)}
            </LinkButton>
          </Text>
        </Fragment>
      )}
    </div>
  );
};

export default OnboardingCriteria;
